import { render } from "./PopupRoot.vue?vue&type=template&id=5b4bdc99&ts=true"
import script from "./PopupRoot.vue?vue&type=script&lang=ts"
export * from "./PopupRoot.vue?vue&type=script&lang=ts"

import "./PopupRoot.vue?vue&type=style&index=0&id=5b4bdc99&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__